import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  LinkButton,
  Modal,
  ModalTrigger,
  PrimaryButton,
  Text,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { t } from "i18next";
import { useFlags } from "launchdarkly-react-client-sdk";

export function RoleLearnMore() {
  const { clientPortalEnableRequestorRole } = useFlags();

  return (
    <ModalTrigger
      trigger={
        <LinkButton testID="what-is-this-role-button">
          {t("What's this?")}
        </LinkButton>
      }
    >
      <Modal>
        <Dialog width="456px">
          {({ close }) => (
            <>
              <DialogHeader onClose={close}>{t("User roles")}</DialogHeader>
              <DialogContent>
                <div className={styles.learnMoreModalBody}>
                  <div className={styles.bodySection}>
                    <Text style="global/heading-medium">{t("Admin")}</Text>
                    <Text style="global/body-primary">
                      {t(
                        "This role is for anyone who needs full access to all functionalities across regions within the account. They can see and manage almost anything."
                      )}
                    </Text>
                  </div>
                  <div className={styles.bodySection}>
                    <Text style="global/heading-medium">{t("Manager")}</Text>
                    <Text style="global/body-primary">
                      {t(
                        "This role is for anyone who needs the ability to manage details within their assigned groups, along with additional features such as tag management and check settings. They cannot view and manage groups they’re not invited to."
                      )}
                    </Text>
                  </div>
                  <div className={styles.bodySection}>
                    <Text style="global/heading-medium">
                      {t("Contributor")}
                    </Text>
                    <Text style="global/body-primary">
                      {t(
                        "This role is for people who need the basics, like ordering and reviewing cases within their assigned groups. They cannot manage user access to groups, view invoices or make decisions on other users’ cases. "
                      )}
                    </Text>
                  </div>
                  <div className={styles.bodySection}>
                    <Text style="global/heading-medium">{t("Billing")}</Text>
                    <Text style="global/body-primary">
                      {t(
                        "This role is for people who need to view and manage invoices, billing profiles, payments, and export data. They cannot order or manage cases. "
                      )}
                    </Text>
                  </div>
                  {clientPortalEnableRequestorRole ? (
                    <div className={styles.bodySection}>
                      <Text style="global/heading-medium">
                        {t("Requestor")}
                      </Text>
                      <Text style="global/body-primary">
                        {t(
                          "This role is for users who need to initiate checks and track progress without accessing sensitive report data. They can order checks and view case status, but cannot view reports or scores. A reviewer must be assigned to review reports and make the final decision."
                        )}
                      </Text>
                    </div>
                  ) : null}
                </div>
              </DialogContent>
              <DialogFooter>
                <PrimaryButton onPress={close} size="medium">
                  {t("Close")}
                </PrimaryButton>
              </DialogFooter>
            </>
          )}
        </Dialog>
      </Modal>
    </ModalTrigger>
  );
}

const styles = {
  learnMoreModalBody: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-4)",
  }),
  bodySection: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-2)",
  }),
};
